export default "__VITE_ASSET__cf198d18__"